/**
 * True when a login token is stored. Always false while the public pages are prerendered at build
 * time, where there is no localStorage; the browser re-evaluates it once the page hydrates.
 */
export function hasStoredToken(): boolean {
  return typeof localStorage !== 'undefined' && !!localStorage.getItem('token');
}
